import { useEffect, useRef, useState } from 'react'

import { useParams } from 'react-router-dom'

import { FormWMSInventario } from '../../../components/Forms/WMSInventario'

import WmsInventarioService from '../../../services/database/WmsInventarioService'

import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'

export function WMSGerenciarInventario() {
  const [isInventarioLoading, setIsInventarioLoading] = useState(true)

  const params = useParams()
  const ref = useRef()

  async function getInventoryById(id) {
    try {
      setIsInventarioLoading(true)

      const data = await WmsInventarioService.getById(id)

      ref.current?.sendData(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao carregar as informações do inventário')
    } finally {
      setIsInventarioLoading(false)
    }
  }

  useEffect(() => {
    if (params?.id) {
      getInventoryById(params.id)
    }
  }, [params.id])

  return (
    <FormWMSInventario
      ref={ref}
      isLoading={isInventarioLoading}
    />
  )
}
